import React, { useState } from "react";
import { SCUIButton } from "../../atoms";

export function SCUIHoverEnvironment() {
  const [isHovered, setIsHovered] = useState(false);
  const toggleHover = () => {
    setIsHovered(!isHovered);
  };
  const toggleHoverClose = () => {
    setIsHovered(false);
  };
  const buttonStyles = {
    padding: "10px 20px",
    backgroundColor: isHovered ? "#0056b3" : "#007bff",
    color: "#fff",
    border: "none",
    cursor: "pointer",
    transition: "background-color 0.3s ease",
  } as React.CSSProperties;

  const containerStyles = {
    display: "inline-block",
    position: "relative",
  } as React.CSSProperties;

  const subButtonsContainerStyles = {
    position: "absolute",
    top: "100%",
    left: "0",
    display: "flex",
    flexDirection: "column",
    color: "white",
    gap: "10px",
    backgroundColor: "#fff",
    border: "1px solid #ccc",
    borderTop: "none",
    borderRadius: "0 0 5px 5px",
    padding: "10px",
    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.2)",
    opacity: isHovered ? "1" : "0",
    pointerEvents: isHovered ? "auto" : "none",
    transition: "opacity 0.3s ease",
  } as React.CSSProperties;

  return (
    <div
      className="button-container"
      style={containerStyles}
      onMouseLeave={toggleHoverClose}
    >
      <button
        className="main-button"
        style={buttonStyles}
        onMouseUp={toggleHover}
      >
        Ortam
      </button>
      {isHovered && (
        <div className="sub-buttons" style={subButtonsContainerStyles}>
          <SCUIButton
            style={{ color: "white" }}
            className="sub-button"
            href={`https://backoffice-dev.lcwaikiki.com${window.location.pathname}${window.location.search}${window.location.hash}`}
            type={"primary"}
            sizeType={"fixed"}
            size={"m"}
            text={""}
          >
            Dev
          </SCUIButton>
          <SCUIButton
            style={{ color: "white" }}
            className="sub-button"
            href={`https://botest.lcwecommerce.com${window.location.pathname}`}
            type={"primary"}
            sizeType={"fixed"}
            size={"m"}
            text={""}
          >
            test
          </SCUIButton>
          <SCUIButton
            style={{ color: "white" }}
            className="sub-button"
            href={`https://bopreprod.lcwecommerce.com${window.location.pathname}${window.location.search}${window.location.hash}`}
            type={"primary"}
            sizeType={"fixed"}
            size={"m"}
            text={""}
          >
            Preprod
          </SCUIButton>
          <SCUIButton
            style={{ color: "white" }}
            className="sub-button"
            href={`https://bopilot.lcwaikiki.com${window.location.pathname}${window.location.search}${window.location.hash}`}
            type={"primary"}
            sizeType={"fixed"}
            size={"m"}
            text={""}
          >
            Pilot
          </SCUIButton>
          <SCUIButton
            style={{ color: "white" }}
            className="sub-button"
            href={`https://bo.lcwaikiki.com${window.location.pathname}${window.location.search}${window.location.hash}`}
            type={"primary"}
            sizeType={"fixed"}
            size={"m"}
            text={""}
          >
            <strong>Prod</strong>
          </SCUIButton>
        </div>
      )}
    </div>
  );
}

export default SCUIHoverEnvironment;
